import { getState } from '@src/utils';
import { RequestConfig } from './api-service';
import { addAdminTokenHeader, AdminAxiosConfig } from '@src/config';
import ClientApi from '@src/types/client';
import { AxiosResponse } from 'axios';

export const adminRefreshTokenService = async (
  config?: RequestConfig
): Promise<ClientApi.AdminAuth.AdminRefreshToken.Response> => {
  const state = getState();
  const token = state?.adminTokens?.SessionToken || '';

  const configWithToken = addAdminTokenHeader(token || '');

  return AdminAxiosConfig.put<
    ClientApi.AdminAuth.AdminRefreshToken.Response,
    AxiosResponse<ClientApi.AdminAuth.AdminRefreshToken.Response>
  >(`/api/v1/admin/refresh-session-token`, {}, { ...config, ...configWithToken }).then(
    (res) => res.data
  );
};
